// extracted by mini-css-extract-plugin
export default {"submitButton":"_2fC7BMXxpsAjst5ZMlUCfU success expand large","heading":"zXx3rxLyyfcEcja9l0GuW","subHeading":"_28izjMsO74oCCA96biVXLr","form":"_1ppatqyVCYinGcqVsOrOjz"};